import axios from "axios";
import { getToken } from "./Auth";

const api = axios.create({
  //baseURL: "/api",
  baseURL: "https://resflow.ddev.site:4001",
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.common["Authorization"] = "Bearer " + token;
    return config;
  }
  return config;
});
export default api;
